import React, { Component } from 'react';
import { Input, Button, Icon, Dropdown, Checkbox } from 'semantic-ui-react';
import objectFitImages from 'object-fit-images';
import axios from 'axios';
import _ from 'lodash';

import CopyProvider from '../copy_provider';
import chargingIconL1 from '../../component/img/charging_graphic_L1.png';
import chargingIconL2 from '../../component/img/charging_graphic_L2.png';
import chargingIconL3 from '../../component/img/charging_graphic_L3.png';
import appStoreBadge from '../../component/img/app_store_badge.png';
import googlePlayBadge from '../../component/img/google-play-badge.png';
import evgoMap from '../../component/img/evgo_map.png';
import evgoApp from '../../component/img/evgo_app.png';
import states from '../../fixtures/states.json';
import locations from '../../fixtures/locations.json';
import makes from '../../fixtures/makes.json';
import models from '../../fixtures/models.json';
import './registration.css';

export default class Registration extends Component {
  constructor() {
    super();

    this.state = {
      formType: 'register',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      state: null,
      zip: '',
      vehicle_make: '',
      vehicle_model: '',
      year: '',
      password: '',
      confirmPassword: '',
      location: 'Home',
      otherVehicle: null,
      terms: false,
      subscribe: true,
      errorMessage: null,
      submitDisabled: false,
      errors: {
        firstName: false,
        lastName: false,
        email: false,
        phone: false,
        address: false,
        city: false,
        state: false,
        zip: false,
        vehicle_make: false,
        vehicle_model: false,
        year: false,
        password: false,
        confirmPassword: false,
        otherVehicle: false,
        terms: false,
      },
    };

    this.validate = this.validate.bind(this);
    this.shouldSubmit = this.shouldSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.formatPhoneNumber = this.formatPhoneNumber.bind(this);
  }

  validate(value, type) {
    const addressRegex = /(^\d{1,})\s(.{1,})/;
    const cityRegex = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/;
    const zipRegex = /^\d{5}(?:[-\s]\d{4})?$/;
    const nameRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g;
    const emailRegex = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+[\]{}\\|;:'",<.>/?])[A-Za-z\d!@#$%^&*()\-_=+[\]{}\\|;:'",<.>/?]{8,}/;
    const phoneRegex = /^(1|)?(\d{3})(\d{3})(\d{4})$/;

    if (type === 'address') return addressRegex.test(value);
    if (type === 'city') return cityRegex.test(value);
    if (type === 'zip') return zipRegex.test(value);
    if (type === 'firstName') return nameRegex.test(value);
    if (type === 'lastName') return nameRegex.test(value);
    if (type === 'email') return emailRegex.test(value);
    if (type === 'phone') return phoneRegex.test(value);
    if (type === 'password') return passwordRegex.test(value);
    if (type === 'confirmPassword') return this.state.password === value;
    if (type === 'otherVehicle') return value !== null;

    return Boolean(value);
  }

  shouldSubmit() {
    if (this.state.formType === 'register'
        && this.validate(this.state.firstName, 'firstName')
        && this.validate(this.state.lastName, 'lastName')
        && this.validate(this.state.email, 'email')
        && this.validate(this.state.phone, 'phone')
        && this.validate(this.state.address, 'address')
        && this.validate(this.state.city, 'city')
        && this.validate(this.state.state, 'state')
        && this.validate(this.state.zip, 'zip')
        && this.validate(this.state.vehicle_make, 'make')
        && this.validate(this.state.vehicle_model, 'model')
        && this.validate(this.state.year, 'year')
        && this.validate(this.state.password, 'password')
        && this.validate(this.state.confirmPassword, 'confirmPassword')
        && this.validate(this.state.location, 'location')
        && this.validate(this.state.otherVehicle, 'otherVehicle')
        && this.validate(this.state.terms, 'terms')) {
      return true;
    } else if (this.state.formType === 'login'
        && this.validate(this.state.email, 'email')
        && this.validate(this.state.password, 'password')
        && this.validate(this.state.location, 'location')
        && this.validate(this.state.otherVehicle, 'otherVehicle')
        && this.validate(this.state.terms, 'terms')) {
      return true;
    }

    return false;
  }

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return phoneNumberString;
  }

  handleSubmit() {
    if (this.shouldSubmit()) {
      this.setState({ errorMessage: null, submitDisabled: true }, () => {
        const data = {
          promotion_id: 'borrow_fmf',
          action: 'registration',
          ref_value: this.props.ref_value,
          code_type: this.props.code_type,
          code_value: this.props.code_value,
          ...this.state,
        };

        delete data.errors;
        delete data.confirmPassword;
        delete data.errorMessage;
        delete data.submitDisabled;

        if (this.state.formType === 'login') {
          delete data.firstName;
          delete data.lastName;
          delete data.password;
          delete data.phone;
          delete data.address;
          delete data.city;
          delete data.state;
          delete data.zip;
          delete data.vehicle_make;
          delete data.vehicle_model;
          delete data.year;
        } else {
          data.phone = (data.phone.match(/\d/g) || []).join('');
        }

        const headers = {
          'Content-Type': 'application/json',
          'Authorization': 'yFbK3PCEjeGaM',
        };

        axios.post('https://api-service.evgo.com/promotion', data, headers)
          .then((res) => {
            if (res.data.success) {
              axios({
                url: 'https://services.evgo.com/int_service/opt_in',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                data: {
                  access_token: 'cb4702d3f3cd69e09a0563d0dcdc4d54d0023693',
                  email: this.state.email,
                  mobile_phone: this.state.phone,
                  promotion_copy: 'By checking the box, you consent to receiving promotions from, or on behalf of EVgo via email or automated text message.  Your consent is not a condition of purchase and message and data rates may apply.',
                  promotion_box: this.state.subscribe ? 1 : 0,
                }
              }).then((res) => {}).catch((err) => console.error(err));

              this.props.updateStep('email_confirmation', this.props.ref_value, res.data.success_type);
            } else if (res.data.errorType === 'PAYMENT_METHOD_NOT_FOUND') {
              this.props.updateStep('registration_payment_method_not_found');
            } else this.props.updateStep('server_error', res.data.errorType || res.data.error_message);
          })
          .catch((err) => {
            console.log(err);
            this.props.updateStep('server_error', err.message);
          });
      });
    } else {
      const { errors } = this.state;
      let currentErrors = errors;
      let firstError = null;

      if (this.state.formType === 'login') currentErrors = { email: false, password: false, otherVehicle: false, terms: false };

      _.forEach(errors, (v, k) => {
        const e = !this.validate(this.state[k], k);

        if (e && !firstError && typeof currentErrors[k] !== 'undefined') firstError = k;
        errors[k] = e;
      });

      if (this.state.formType === 'login' && firstError === 'password') {
        this.setState({ errorMessage: `Error: Invalid ${firstError}.` });
      } else {
        this.setState({ errors }, () => {
          this.setState({ errorMessage: `Error: Invalid ${_.startCase(firstError)}.` });
        });
      }
    }
  }

  dateRange(start, end) {
    return (new Array(end - start + 1)).fill(undefined).map((_, i) => i + start).map(year => ({ text: year, value: year })).reverse();
  }

  render() {
    const date = new Date();
    let filteredModels = [];
    let filteredYears = [];
    if (this.state.vehicle_make) filteredModels = models.filter(model => model.make === this.state.vehicle_make);
    if (this.state.vehicle_model) filteredYears = filteredYears = this.dateRange(2000, date.getFullYear() + 1);

    const toggleProps = (formType) => {
      return {
        className: `registration_form_content_form_toggle${(this.state.formType === formType) ? ' blue' : ''}`,
        disabled: (this.state.formType === formType),
        onClick: () => {
          this.setState({ formType: formType });
        },
      };
    };

    const inputProps = (key, placeholder, length, type, options, defaultValue, checked, value, disabled) => {
      return {
        key: (type !== 'checkbox') ? key : undefined,
        className: (type !== 'dropdown') ?  (() => {
          let className;

          if (type !== 'checkbox') {
            className = 'registration_form_input';
            if (length) className += ` ${length}`;
          } else {
            if (this.state.errors[key]) className = 'error';
          }

          return className;
        })() : undefined,
        type: (type !== 'dropdown' && type !== 'checkbox') ? type : undefined,
        placeholder: (type !== 'checkbox') ? placeholder : undefined,
        options: (type === 'dropdown') ? options : undefined,
        label: (type === 'checkbox') ? placeholder : undefined,
        checked: (type === 'checkbox' && typeof checked === 'boolean') ? (this.state[key] === checked) : undefined,
        fluid: (type === 'dropdown') ? true : undefined,
        selection: (type === 'dropdown') ? true : undefined,
        defaultValue: (type !== 'checkbox') ? defaultValue : undefined,
        value,
        disabled,
        error: (type !== 'checkbox' && this.state.errors[key]) ? this.state.errors[key] : undefined,
        onBlur: (!disabled && type !== 'checkbox') ? () => {
          this.setState({ errors: { ...this.state.errors, [key]: !this.validate(this.state[key], key) } });
        } : undefined,
        onChange: (!disabled) ? (e, d) => {
          let v = d.value;

          if (type === 'checkbox') {
            if (typeof checked === 'boolean') v = checked;
            else v = d.checked;
          }

          this.setState({ [key]: v }, () => {
            if (key === 'vehicle_make') this.setState({ vehicle_model: '', year: '' });
            if (key === 'vehicle_model') this.setState({ year: '' });
            if (key === 'password' || key === 'confirmPassword') this.setState({ errors: { ...this.state.errors, confirmPassword: !(this.state.password === this.state.confirmPassword) } });
            if (type === 'checkbox') this.setState({ errors: { ...this.state.errors, [key]: !this.validate(this.state[key], key) } });
          });
        } : undefined,
        onKeyDown: (!disabled) ? (e) => {
          if (e.which === 13) this.handleSubmit();
        } : undefined,
      };
    };

    return [
      <div key="registration_header" className="registration_header">
        <CopyProvider copyKey={ `registration_header_${this.props.ref_value}` } ref_value={ this.props.ref_value } />
      </div>,

      <nav key="registration_nav" className="registration_nav">
        <a className="active" href="#register">Register</a>
        <a href="#fastcharging">What is Fast Charging?</a>
        <a href="#evgo">EVgo</a>
      </nav>,

      <div key="registration_form" id="register" className="registration_form">
        <div className="registration_form_content">
          <span className="registration_form_content_title blue">Register and Start Fast Charging Your New EV Today</span>
          <CopyProvider copyKey={ `registration_form_content_list_${this.props.ref_value}` } ref_value={ this.props.ref_value } />

          <div className="registration_form_content_form">
            <div className="registration_form_content_form_toggle">
              <Button { ...toggleProps('register') }>Register for an EVgo Account</Button>
              <Button { ...toggleProps('login') }>Already have an EVgo account?</Button>
            </div>

            <div className="registration_form_content_form_container">
              {
                (this.state.formType === 'register') ?
                  [
                    <Input { ...inputProps('firstName', 'First Name', 'half', undefined, undefined, undefined, undefined, this.state.firstName) }/>,
                    <Input { ...inputProps('lastName', 'Last Name', 'half', undefined, undefined, undefined, undefined, this.state.lastName) }/>,
                    <Input { ...inputProps('email', 'Email', 'half', 'email', undefined, undefined, undefined, this.state.email) }/>,
                    <Input { ...inputProps('phone', 'Phone#', 'half', 'tel', undefined, undefined, undefined, this.state.phone) }/>,
                    <Input { ...inputProps('address', 'Address', undefined, undefined, undefined, undefined, undefined, this.state.address)}/>,
                    <Input { ...inputProps('city', 'City', 'half', undefined, undefined, undefined, undefined, this.state.city) }/>,
                    <div key="state" className="registration_form_input quarter">
                      <Dropdown { ...inputProps('state', 'State', undefined, 'dropdown', states, undefined, undefined, this.state.state) }/>
                    </div>,
                    <Input { ...inputProps('zip', 'Zip', 'quarter', undefined, undefined, undefined, undefined, this.state.zip) }/>,
                    <div key="make" className="registration_form_input quarter">
                      <Dropdown { ...inputProps('vehicle_make', 'Make', null, 'dropdown', makes, undefined, undefined, this.state.vehicle_make) }/>
                    </div>,
                    <div key="model" className="registration_form_input half">
                      <Dropdown { ...inputProps('vehicle_model', 'Model', null, 'dropdown', filteredModels, undefined, undefined, this.state.vehicle_model, filteredModels.length > 0 ? false : true) }/>
                    </div>,
                    <div key="year" className="registration_form_input quarter">
                      <Dropdown { ...inputProps('year', 'Year', null, 'dropdown', filteredYears, undefined, undefined, this.state.year, filteredYears.length > 0 ? false : true) }/>
                    </div>,
                    <Input { ...inputProps('password', 'Create Password', 'half', 'password', undefined, undefined, undefined, this.state.password) }/>,
                    <Input { ...inputProps('confirmPassword', 'Re-enter Password', 'half', 'password', undefined, undefined, undefined, this.state.confirmPassword) }/>,
                    <span key="footnote" className="registration_form_footnote">Minimum 8 chars: with at least 1 number, 1 uppercase, 1 lowercase & 1 special character (!, @, # ...)</span>,
                  ]
                :
                  [
                    <span key="label" className="registration_form_label">Log in here and the promotional credit will be added to your account.</span>,
                    <Input { ...inputProps('email', 'Email', undefined, 'email', undefined, undefined, undefined, this.state.email) }/>,
                    <Input { ...inputProps('password', 'Password', undefined, 'password', undefined, undefined, undefined, this.state.password) }/>,
                    <span key="footnote" className="registration_form_footnote">Minimum 8 chars: with at least 1 number, 1 uppercase, 1 lowercase & 1 special character (!, @, # ...)</span>,
                  ]
              }
              <span className="registration_form_label">Currently, what is your primary charging location for your EV?</span>
              <div className="registration_form_input">
                <Dropdown { ...inputProps('location', 'Location', undefined, 'dropdown', locations, 'Home') }/>
              </div>
              <span className="registration_form_label">Do you own or lease a 2nd vehicle that is gasoline or hybrid?</span>
              <div className="registration_form_radios">
                <Checkbox { ...inputProps('otherVehicle', 'Yes', undefined, 'checkbox', undefined, undefined, true) }/>
                <Checkbox { ...inputProps('otherVehicle', 'No', undefined, 'checkbox', undefined, undefined, false) }/>
              </div>
              <hr />
              <Checkbox { ...inputProps('subscribe', 'By checking the box, you consent to receiving promotions from, or on behalf of EVgo via email or automated text message. Your consent is not a condition of purchase and message and data rates may apply.' , undefined, 'checkbox') } checked={ this.state.subscribe} />
              <Checkbox { ...inputProps('terms', <label>
                By checking this box, you acknowledge you have read and agree to be bound
                by our <a target="_blank" rel="noopener noreferrer" href="https://www.evgo.com/terms-service/">Terms of Service</a> {' '}
                and our <a target="_blank" rel="noopener noreferrer" href="https://www.evgo.com/privacy-policy/">Privacy Policy</a>. By submitting this form,
                you acknowledge you are sharing your personal information with EVgo and
                consent to EVgo’s Privacy Notice for California Residents. More detail
                regarding personal information we collect, how we use that information,
                how we share that information, and your rights and choices can be found
                in our <a target="_blank" rel="noopener noreferrer" href="https://www.evgo.com/privacy-policy/">Privacy Policy</a>.
                </label> , null, 'checkbox') }/>
              <div className="registration_form_error">{ this.state.errorMessage }</div>
              <div className="registration_form_submit">
                <Button className="blue" style={{ 'backgroundColor': '#00AEEF', 'color': '#FFFFFF' }} onClick={ this.handleSubmit } disabled={ this.state.submitDisabled }>
                  { (this.state.formType === 'register') ? 'Register' : 'Login' }
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>,

      <div key="registration_fastcharging" id="fastcharging" className="registration_fastcharging">
        <div className="registration_fastcharging_info">
          <div className="blue">What is Fast Charging?</div>
          <span>Fast charging is compatible with your EV and can provide up to 90 miles of range in 30 minutes of charging. Whether you are around town running errands, or topping off during long-distance travel, fast charging will get you back on the road with more range and in less time compared to Level 1 or 2 charging.</span>
        </div>

        <div className="registration_fastcharging_levels">
          <div className="registration_fastcharging_level">
            <img src={ chargingIconL1 } alt="" />

            <span>
              <div style={{ paddingTop: '8px'}}>Level 1 Charging</div>
              <span>Up to 2 miles, 30 minutes</span>
            </span>
          </div>

          <div className="registration_fastcharging_level">
            <img src={ chargingIconL2 } alt="" />

            <span>
              <div style={{ paddingTop: '8px'}}>Level 2 Charging</div>
              <span>Up to 10 miles, 30 minutes</span>
            </span>
          </div>

          <div className="registration_fastcharging_level">
            <img src={ chargingIconL3 } alt="" />

            <span>
              <div className="blue" style={{ paddingTop: '8px'}}>Level 3 Fast Charging</div>
              <span>Up to 90 miles, 30 minutes</span>
            </span>
          </div>
        </div>
      </div>,

      <div key="registration_fastcharging_banner" className="registration_fastcharging_banner"></div>,

      <div key="registration_evgo_title" id="evgo" className="registration_evgo_title blue">
        EVgo: The Nation’s Largest Public Fast Charging Network
      </div>,

      <div key="registration_evgo_banners" className="registration_evgo_banners">
        <img src={ evgoMap } alt="" />
        <img src={ evgoApp } alt="" />
      </div>,

      <div key="registration_evgo_info"className="registration_evgo_info">
        EVgo has more than 1,100 fast charging stations nationwide. The EVgo app allows you to find local chargers, check availability, and even initiate a charge with just a swipe of a finger! To see all of our nationwide locations, please click <a href="https://www.evgo.com/charging-locations/" target="_blank" rel="noopener noreferrer">here</a>.

        <div key="registration_evgo_app_info" className="registration_evgo_app_info" id="app-store">
          Download the app today!
          <a href="https://itunes.apple.com/us/app/evgo/id1281660968?mt=8" target="_blank" rel="noopener noreferrer"><img src={ appStoreBadge } alt="" /></a>
          <a href="https://play.google.com/store/apps/details?id=com.driivz.mobile.android.evgo.driver" target="_blank" rel="noopener noreferrer"><img src={ googlePlayBadge } alt="" /></a>
        </div>
      </div>,

      <div key="registration_footer" className="registration_footer">
        <div className="registration_footer_content">
          <div className="registration_footer_content_left">
            <div>
              <Icon className="blue"  name="question circle" />
              <b>Questions?</b>
            </div>

            <div>Call <b>877-494-3833</b> or email <b><a href="mailto:support@evgo.com" target="_blank" rel="noopener noreferrer">support@evgo.com</a></b></div>
          </div>

          <div className="registration_footer_content_right">
            <b>&copy; 2019 EVgo Services LLC</b>
          </div>
        </div>

        <CopyProvider copyKey={ `registration_footer_fineprint_${this.props.ref_value}` } ref_value={ this.props.ref_value } />
      </div>
    ];
  }

  componentDidMount() {
    objectFitImages();
  }

  componentDidUpdate() {
    objectFitImages();
  }
}



// WEBPACK FOOTER //
// ./src/content/registration/registration.js